<template>
  <div class="spinner-wrapper">
    <div class="spinner">
      <div class="bounce1" />
      <div class="bounce2" />
      <div class="bounce3" />
    </div>
    <h2 class="loadingstatus">
      {{ loadingstatus }}
    </h2>
    <p class="loadingmessage">
      {{ loadingmessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['loadingstatus', 'loadingmessage'],
};
</script>

<style scoped>
.loaderx {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0.75;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.loadingstatus {
  align-items: center;
  color: black;
  font-size: 18px;
  font-weight: 600;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.loadingmessage {
  width: 33.33%;
  align-items: center;
  color: black;
}

.spinner-wrapper {
  position: fixed;
  z-index: 999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  opacity: 0.4;

}

.spinner {
  position: absolute;
  top: 50%; 
  left: 50%; 
  width: 3.75rem;
  height: 1.25rem;
  margin: -0.625rem 0 0 -1.875rem;
  text-align: center;
}

.spinner > div {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  -webkit-animation: spin_bounce_delay 1.4s infinite ease-in-out both;
  animation: spin_bounce_delay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
  background-color: var(--djuli-secondary-color);
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  background-color: var(--djuli-primary-color);
}
.spinner .bounce3 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  background-color: var(--djuli-tertiary-color);
}

@-webkit-keyframes spin_bounce_delay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
   40% {
    -webkit-transform: scale(1);
  }

}

@keyframes spin_bounce_delay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
 
}
</style>